import theme from "assets/styles/themes";

export const POINT_SIZE = 8;
export const BIG_POINT_SIZE = 12;
export const COLORS = [
    "#b87ee7",
    "#e4a55c",
    "#67cc7a",
    "#a62c78",
    "#f28aa7",
    "#ff7d6f",
    "#dca11d",
    "#7d801c",
    "#af9ffa",
    "#a00044",
    "#8ab4f8",
    "#c494ed",
    "#ecc28a",
    "#7ed18b",
    "#91e0e7",
    "#bf4da2",
    "#40f5d0",
    "#f7a7bf",
    "#ff998c",
    "#e3ba40",
    "#979b3c",
    "#c1b5ff",
    "#ba1a60",
    "#6ca4f0",
    "#a66bdc",
    "#f0b875",
    "#8cd69b",
    "#a4e6ed",
    "#d067b5",
    "#57f7da",
    "#f9c3d4",
    "#ffad9d",
    "#eace5c",
    "#b1b559",
    "#d7cdff",
    "#d23a78",
    "#9ec2fb",
    "#e0aee0",
];

export const WATERMARK = `Source L-CAP GROUP LTD (${new Date().getFullYear()}) &nbsp;&nbsp; © L-CAP GROUP LTD`;

// Bridge constants
export const BRIDGE_FIRST_ELEMENT = {
    dataLabels: {
        color: theme.palette.text.primary,
        fontWeight: 600,
    },
    color: {
        linearGradient: {
            x1: 0,
            x2: 0,
            y1: 0,
            y2: 1,
        },
        stops: [
            [0, "#267895"],
            [1, "#26789560"],
        ],
    },
};

export const BRIDGE_LAST_ELEMENT = {
    isSum: true,
    color: {
        linearGradient: {
            x1: 0,
            x2: 0,
            y1: 0,
            y2: 1,
        },
        stops: [
            [0, theme.palette.gradients.g02.n1],
            [1, theme.palette.gradients.g02.n2],
        ],
    },
    dataLabels: {
        color: theme.palette.text.primary,
        style: {
            fontSize: 12,
            fontWeight: 600,
        },
    },
};

export const BRIDGE_NEGATIVE_VALUE = {
    dataLabels: {
        verticalAlign: "bottom",
        color: theme.palette.text.primary,
        fontWeight: 600,
        y: 22,
    },
};
